export enum MessageThreadElementType {
    reply = 1,
    satisfaction = 2,
    survey = 3,
    sessionAuthentication = 4,
}
